// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".modern." + {"2897":"a66fee6b2de6889f7641","3490":"6867a60f2801c6d1b6af"}[chunkId] + ".js";
};